import { useId } from "react";

export const LogoMark = ({ className = "h-10 w-10" }) => {
  const clipId = `badge-${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Brightside logo" data-testid="logo-mark">
      <circle cx="24" cy="24" r="24" fill="#C86D51" />
      <clipPath id={clipId}>
        <circle cx="24" cy="24" r="24" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <g stroke="#FAF7F2" strokeWidth="2.4" strokeLinecap="round">
          <line x1="24" y1="6" x2="24" y2="11" />
          <line x1="12.7" y1="10.7" x2="15.4" y2="14.4" />
          <line x1="35.3" y1="10.7" x2="32.6" y2="14.4" />
          <line x1="7" y1="20" x2="11.6" y2="22.6" />
          <line x1="41" y1="20" x2="36.4" y2="22.6" />
        </g>
        <circle cx="24" cy="29" r="9.5" fill="#FAF7F2" />
        <path d="M-2 33 C 8 27, 18 32.5, 26 30.5 C 34 28.5, 42 29.5, 50 33 L 50 50 L -2 50 Z" fill="#1C3829" />
        <path d="M-2 37.5 C 10 33.5, 22 37.5, 32 35.5 C 40 34, 46 35.5, 50 37.5 L 50 50 L -2 50 Z" fill="#467055" opacity="0.6" />
      </g>
    </svg>
  );
};

export const LogoLockup = ({ className = "", markClass = "h-11 w-11", light = false }) => (
  <span className={`flex items-center gap-2.5 ${className}`} data-testid="logo-lockup">
    <LogoMark className={markClass} />
    <span className="leading-none">
      <span className={`block font-serif text-xl font-semibold tracking-tight ${light ? "text-linen" : "text-forest"}`}>Brightside</span>
      <span className={`block text-[10px] font-semibold uppercase tracking-[0.28em] ${light ? "text-sage-light" : "text-sage"}`}>Befriending · Glasgow</span>
    </span>
  </span>
);
